<template>
  <div>
    <vue-base-dialog  :dialogConfig="dialogConfig" class="selfCreateDialog">
        <div class="dialog-content">
           <p class="content">该试卷共{{this.dialogConfig.data.questionsNum}}道试题，您还有{{this.dialogConfig.data.questionsNum-this.dialogConfig.data.dataArr.length}}道试题没有回答，是否继续交卷？</p>
           <div class="button">
                <a-button class="button-cancle" shape="round" @click="cancel()">取消</a-button>
                <a-button class="button-suer" type="primary" shape="round" @click="sure()">确定</a-button>
            </div>
        </div>
    </vue-base-dialog>
  </div>
</template>

<script>
import VueBaseDialog from '@/components/VueBaseDialog'
import services from "../../../../config/services";
export default {
    name:"assessDialog2",
    props:{
        dialogConfig: {
          type: Object,
        }
    },
    components: {
       VueBaseDialog,
    },
    data(){
        return{
            services: services,
            school_code: localStorage.getItem("schoolCode")
        }
    },
    methods:{
        //取消关闭窗口
        cancel(){
            this.$emit("cancleDialog",null);
        },
        sure(){
            let that = this;
            if(that.dialogConfig.data.params){
                let params = that.dialogConfig.data.params
                // answer 为富文本字符串，请求前对其中的 HTML 标签进行转义
                if (params.answer && typeof params.answer === 'string') {
                    params.answer = params.answer.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
                }
                services.assessModify(params).then((res) => {
                    if (res.code == "0000") {
                        if(params.subtype == 2){  // 1单个题目提交2练习提交(
                            if(res.data && res.data.show_result){
                                // show_result 交卷后展示测评结果 1开启 2关闭
                                if(res.data.show_result == 1){
                                    that.$router.push({
                                        //跳转到再次测评
                                        path: `/${that.school_code}/user/myAssess/againAssess`,
                                        query: {
                                            ass_id: that.dialogConfig.data.ass_id,
                                            assessName: that.dialogConfig.data.assessName,
                                            record_id: that.dialogConfig.data.record_id,
                                            class_id: that.dialogConfig.data.class_id,
                                            tabs: 0,
                                        },
                                    });
                                } else { 
                                    that.$router.push({
                                        //跳转到测评结束页面
                                        path: `/${that.school_code}/user/myAssess/endAssess`,
                                        query: {
                                            time: res.data.use_duration
                                        },
                                    });
                                }
                            }
                            
                        }
                    } else {
                        this.$message.warning(res.message ? res.message : "提交失败");
                    }
                });
            }
        },
        // sure(){
        //     if(this.dialogConfig.data.dataArr.length==0){
        //         services.assessModify({
        //             ass_id:this.dialogConfig.data.ass_id
        //         }).then((res) =>{
        //             if(res.code == "0000"){
        //                 this.$router.push({
        //                     //跳转到再次测评
        //                     path:"/user/myAssess/againAssess",
        //                     query:{
        //                         ass_id:this.dialogConfig.data.ass_id,
        //                         assessName:this.dialogConfig.data.assessName,
        //                         record_id:res.data.record_id,
        //                         tabs:0,
        //                     }
        //                 });
        //             }
        //         });
        //     }else{
        //         services.assessModify({
        //             ass_id:this.dialogConfig.data.ass_id,
        //             answer_data:JSON.stringify(this.dialogConfig.data.dataArr),
        //         }).then((res) =>{
        //             if(res.code =="0000"){
        //                 this.$router.push({
        //                     //跳转到再次测评
        //                     path:"/user/myAssess/againAssess",
        //                     query:{
        //                         ass_id:this.dialogConfig.data.ass_id,
        //                         assessName:this.dialogConfig.data.assessName,
        //                         record_id:res.data.record_id,
        //                         tabs:0,
        //                     }
        //                 });
        //             }
        //         });
        //     }
           
        // },
    },

}
</script>

<style lang="less" scoped>
.dialog-content{
   padding: 20px 40px;
   width: 470px;
   padding-top: 40px;
   overflow: hidden;
}
.button{
    margin-top: 40px;
    float: right;
}
.button-cancle,.button-suer{
    border-radius: 5px;
    margin-right: 20px;
}
.content{
    color: #666666;
}
</style>